"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MortageRateChangeModal = require("./MortageRateChangeModal");
Object.keys(_MortageRateChangeModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MortageRateChangeModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MortageRateChangeModal[key];
    }
  });
});